import { DecimalPipe, Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AddBillRQ, CustomerRP, AddCustomerWithSenderRQ, BillService, CityService, CustomerSenderModel, CustomerService, GetBillRQ, GetSenderByNumberRP, GetSenderByNumberRQ, ListCityByStateRQ, SenderService, StateModel, ListStateRQ, StateService, UpdateBillRQ } from 'app/open-api';
import { UploadService } from 'app/shared/services/upload.service';
import Stepper from 'bs-stepper';
import { NgxSpinnerService } from 'ngx-spinner';
import { timeout } from 'rxjs/operators';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-bill-create',
  templateUrl: './bill-create.component.html',
  styleUrls: ['./bill-create.component.scss'],
  providers: [DecimalPipe]
})
export class BillCreateComponent implements OnInit {

  private verticalWizardStepper: Stepper;
  sender?: GetSenderByNumberRP;
  customer?: CustomerSenderModel;
  senderForm: FormGroup;
  customerForm: FormGroup;
  detailForm: FormGroup;
  billDoc: File;
  billDocName: string;
  cities: any[] = [];
  states: StateModel[] = [];
  emptyMessage?: string;
  billId?: string;
  isEditMode = false;
  isExternalBill = false;
  date = new Date();
  today = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: this.date.getDate() };

  constructor(
    private location: Location,
    private billService: BillService,
    private customerService: CustomerService,
    private senderService: SenderService,
    private stateService: StateService,
    private cityService: CityService,
    private uploadService: UploadService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private decimalPipe: DecimalPipe
  ) {
    this.billId = this.route.snapshot.paramMap.get('billId');
    if (this.billId) {
      this.isEditMode = true;
    }
  }

  async ngOnInit(): Promise<void> {
    this.FetchState(1);
    this.senderForm = new FormGroup({
      senderName: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z ]+'), Validators.maxLength(60)]),
      senderPhone: new FormControl(null, Validators.required)
    });
    this.customerForm = new FormGroup({
      customerPhone: new FormControl(null, Validators.required),
      customerName: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z ]+'), Validators.maxLength(60),]),
      customerCity: new FormControl({ value: null, disabled: true }, Validators.required),
      customerState: new FormControl(null, Validators.required),
      customerAddress: new FormControl(null),
      customerReferencePoint: new FormControl(null),
      customerIdentityCard: new FormControl(null)
    });
    this.detailForm = new FormGroup({
      pounds: new FormControl(null, Validators.required),
      price: new FormControl(null, Validators.required),
      services: new FormControl(null, Validators.required),
      total: new FormControl(null, Validators.required),
      code: new FormControl(null, Validators.required),
      createAt: new FormControl(this.today, Validators.required),
      sendSMS: new FormControl(false, Validators.required)
    });
    this.verticalWizardStepper = new Stepper(document.querySelector('#stepper2'), {
      linear: true,
      animation: true
    });
    await this.GetBillModel();
  }

  FetchState(type: number) {
    this.spinner.show();
    let request: ListStateRQ = {
     type: type
    }
    
    this.stateService.apiStateListGet(request).subscribe(res => {
      this.states = res.list;
      this.spinner.hide();
    });
  }

  async GetBillModel(): Promise<void> {
    if (this.billId) {
      this.spinner.show();
      const bill: GetBillRQ = {
        id: parseInt(this.billId, 10)
      };
      this.billService.apiBillGetBillPost(bill).toPromise().then(async res => {        
        this.isExternalBill = res.type == 2 ? true : false;        
        //if(this.isExternalBill)
        //  this.FetchState(2);
        await this.GetCitiesByStateId(res.customerStateId);
        const createAt = new Date(res.createAt);
        const date = { year: createAt.getFullYear(), month: createAt.getMonth() + 1, day: createAt.getDate() };
        this.billDocName = res.file;
        this.sender = JSON.parse(res.senderModel);
        this.customer = JSON.parse(res.customerModel);
        this.senderForm.setValue({
          senderName: JSON.parse(res.senderModel)?.Name,
          senderPhone: JSON.parse(res.senderModel)?.Phone
        });
        this.customerForm.setValue({
          customerPhone: JSON.parse(res.customerModel).Phone,
          customerName: JSON.parse(res.customerModel).Name,
          customerCity: JSON.parse(res.customerModel).CityId,
          customerState: res.customerStateId,
          customerAddress: JSON.parse(res.customerModel).Address,
          customerReferencePoint: JSON.parse(res.customerModel).ReferencePoint,
          customerIdentityCard: JSON.parse(res.customerModel).IdentityCard
        });
        this.detailForm.setValue({
          pounds: res.pounds,
          price: res.price,
          services: res.services,
          code: res.code,
          total: res.total,
          createAt: date,
          sendSMS: res.sendSMS
        });
        this.customerForm.updateValueAndValidity();
        this.senderForm.updateValueAndValidity();
        this.detailForm.updateValueAndValidity();
        this.spinner.hide();
      });
    }
  }

  OnStateChange() {
    this.fc.customerCity.setValue(null);
    this.fc.customerCity.updateValueAndValidity();
    
    if(this.customerForm.get('customerState').value != null && this.customerForm.get('customerState').value != ""){
      const param: ListCityByStateRQ = {
        stateId: this.customerForm.get('customerState').value,
        stateType: this.isExternalBill ? 2 : 1
      };
      this.cityService.apiCityListByStatePost(param).subscribe(res => {
        this.cities = res.list;
        this.customerForm.get('customerCity').enable();
      });
    }    
  }

  async GetCitiesByStateId(stateId: number) {    
    const param: ListCityByStateRQ = {
      stateId,
      stateType: this.isExternalBill ? 2 : 1
    };
    await this.cityService.apiCityListByStatePost(param).toPromise().then(res => {
      this.cities = res.list;
      this.customerForm.get('customerCity').enable();
    });
  }

  Back(): void {
    this.location.back();
  }

  VerticalWizardPrevious(): void {
    this.verticalWizardStepper.previous();
  }

  VerticalWizardNext(): void {
    this.verticalWizardStepper.next();
  }

  LoadFile(event: any): void {
    if (event?.target?.files?.length) {
      this.billDoc = event.target.files[0];
    }
  }

  SearchSenderByNumber(number: string) {
    this.spinner.show();
    const param: GetSenderByNumberRQ = {
      agencyId: 2,
      phone: number
    };
    this.senderService.apiSenderGetSenderByNumberPost(param).subscribe(res => {
      this.emptyMessage = null;
      this.sender = res;
      this.senderForm.setValue({
        senderName: res.name,
        senderPhone: res.phone
      });
      this.senderForm.updateValueAndValidity();
      this.spinner.hide();
    }, error => {
      this.ClearSenderName();
      this.sender = null;
      this.emptyMessage = error;
      this.spinner.hide();
    });
  }

  ClearSenderName() {
    this.senderForm.get('senderName').setValue(null);
    this.senderForm.get('senderName').updateValueAndValidity();
  }

  get fs() {
    return this.senderForm.controls;
  }

  get fd() {
    return this.detailForm.controls;
  }

  get fc() {
    return this.customerForm.controls;
  }

  async SelectedCustomer(customer: CustomerSenderModel) {
    this.customer = customer;
    await this.GetCitiesByStateId(customer.stateId);
    this.customerForm.setValue({
      customerPhone: this.customer.phone,
      customerName: this.customer.name,
      customerCity: this.customer.cityId,
      customerState: this.customer.stateId,
      customerAddress: this.customer.address,
      customerReferencePoint: this.customer.referencePoint,
      customerIdentityCard: this.customer.identityCard
    });
  }

  NewCustomer() {
    this.customer = null;
    this.customerForm.reset();
    this.customerForm.get('customerCity').disable();
  }

  OnChangeValue() {
    const pounds = this.detailForm.get('pounds')?.value || 0;
    const price = this.detailForm.get('price')?.value?.toFixed(2) || 0;
    const services = this.detailForm.get('services')?.value || 0;
    const total = (pounds * price + services).toFixed(2).replace(/[.,]00$/, "");
    this.detailForm.get('total')?.setValue(total);
  }

  OnTotalValueChanged() {
    const pounds = this.detailForm.get('pounds')?.value || 0;
    const total = this.detailForm.get('total')?.value || 0;    
    var price = pounds !== 0 ? (total/pounds).toFixed(2).replace(/[.,]00$/, "") : 0;
    
    this.detailForm.get('price')?.setValue(price);
  }

  async CreateBill() {
    this.spinner.show();
    await this.VerifyFile();
    const senderWithSender: AddCustomerWithSenderRQ = this.SenderWithCustomerModel();
    const customer = await this.customerService.apiCustomerAddWithSenderPost(senderWithSender).toPromise();
    const day = this.fd.createAt.value.day;
    const month = this.fd.createAt.value.month;
    const year = this.fd.createAt.value.year;
    const date = new Date(year, month - 1, day);

    let total : string = this.fd.total.value.toString();
    //let price : string = this.fd.price.value.toString();
    let price = this.detailForm.get('price').value.toString();
    
    if (this.isEditMode) {
      const param: UpdateBillRQ = {
        id: parseInt(this.billId, 10),
        agencyId: 2,
        customerId: customer?.id,
        code: this.fd.code.value.toString(),
        customerPhone: this.fc.customerPhone.value.toString(),
        senderPhone: this.fs.senderPhone.value.toString(),
        file: this.billDocName,
        pounds: this.fd.pounds.value,
        price: parseFloat(price),
        services: this.fd.services.value,
        total: parseFloat(total),
        createAt: date,
        sendSMS: this.fd.sendSMS.value
      };
      await this.billService.apiBillUpdatePost(param).toPromise().then(res => {
        this.spinner.hide();
        Swal.fire({
          title: 'Factura Actualizada',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
          position: 'top-end'
        });

        setTimeout(() => {          
        this.router.navigate(['/pages/bill']);
        }, 1000);
        
      }, error => {
        Swal.fire({
          title: 'Error!. ' + error,
          icon: 'error',
          showConfirmButton: false,
          timer: 2000,
          position: 'top-end'
        });
        this.spinner.hide();
      });
    } else {      
      const param: AddBillRQ = {
        agencyId: 2,
        code: this.fd.code.value.toString(),
        customerPhone: this.fc.customerPhone.value.toString(),
        senderPhone: this.fs.senderPhone.value.toString(),
        file: this.billDocName,
        pounds: this.fd.pounds.value,
        price: parseFloat(parseFloat(price).toFixed(2)),
        services: this.fd.services.value,
        total: parseFloat(this.fd.total.value),
        createAt: date,
        sendSMS: this.fd.sendSMS.value
      };
      
      await this.billService.apiBillAddPost(param).toPromise()
        .then(res => {
          this.spinner.hide();
          Swal.fire({
            title: 'Factura Creada',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000,
            position: 'top-end'
          });
          setTimeout(() => {            
            this.router.navigate(['/pages/bill']);
          }, 1000);
          
        }, error => {
          Swal.fire({
            title: 'Error!. ' + error,
            icon: 'error',
            showConfirmButton: false,
            timer: 2000,
            position: 'top-end'
          });
          this.spinner.hide();
        });
    }
  }

  async VerifyFile() {
    if (this.billDoc) {
      const formData = new FormData();
      //this.billDoc.name = this.fd.code.value.toString()
      formData.append('file', this.billDoc);
      await this.uploadService.UploadFile(formData).toPromise()
        .then(res => {
          this.billDocName = res.text;
        }, error => {
          this.billDocName = error.text;
        });
    }
  }

  SenderWithCustomerModel() {
    const sender = this.senderForm.value;
    const customer = this.customerForm.value;
    const model: AddCustomerWithSenderRQ = {};
    model.customerId = this.customer?.id || null;
    model.senderName = sender.senderName;
    model.senderPhone = sender.senderPhone.toString();
    model.senderId = this.sender?.id || null;
    model.senderAgencyId = 2; // TODO: AgencyId.
    model.address = customer.customerAddress;
    model.cityId = customer.customerCity;
    model.identityCard = customer?.customerIdentityCard?.toString() || '';
    model.name = customer.customerName;
    model.phone = customer.customerPhone?.toString();
    model.referencePoint = customer?.customerReferencePoint || '';

    return model;
  }

  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }

  GetStateNameById(id: number): string {
    if (this.states.length > 0 && id) {
      let state = this.states.find(state => state.id === id);
      return state.name;
    }
    return "";
  }

  GetCityNameById(id: string): string {
    if (this.cities.length > 0 && id) {
      let city = this.cities.find(c => c.id === id);
      return city.name;
    }
    return "";
  }

  NumberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  DecimalsNumberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && charCode != 44 && charCode != 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
